module.exports = __webpack_public_path__ + "static/media/tonikawa.c0033b0b.png";